import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Pagination} from "swiper";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation])

export default function ImageSlider(props) {

    const boxRef = React.createRef()
    const [pageWidth, setPageWidth] = useState(0)

    useEffect(() => {
        if (boxRef.current) {
            setPageWidth(boxRef.current.getBoundingClientRect().width)
        }
    }, [boxRef])

    if (props.sliders !== undefined) {
        let maxWidth = Math.max.apply(Math, props.sliders.map((slide) => {
            return slide.width
        }))
        let maxHeight = Math.max.apply(Math, props.sliders.map((slide) => {
            return slide.height
        }))
        let height = ((pageWidth * (maxWidth / 100)) * (maxHeight / 100))
        return (
            <div ref={boxRef}>
                <Swiper
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: true,
                    }}
                    pagination={true}
                    modules={[Pagination]}>
                    {props.sliders.map((slide, slideIndex) => {
                        if (pageWidth !== 0) {
                            let widthUnit = slide.width + "%"
                            return <SwiperSlide key={slideIndex} className="center">
                                <img className="clickable" style={{width: widthUnit, height: height}}
                                     src={slide.image}
                                     onClick={() => {
                                         props.onClicked(props.sliders[slideIndex])
                                     }} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                            </SwiperSlide>
                        } else {
                            return null
                        }
                    })}
                </Swiper>
            </div>
        )
    } else {
        return (
            <div/>
        )
    }
}